import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import {Subject} from 'rxjs';
import {takeUntil} from "rxjs/operators";
import {PlatformCommand} from "@shared/commands/command-base";
import {Api} from "@shared/constants/common-field.constants";
import {DialogService} from "@shared/services/dialog-service";
import {CommandService} from "@core/services/command.service";
import {SnackBarService} from "@core/services/snack-bar.service";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";

@Component({
    standalone: false,
    selector: 'app-user-roles-cell-viewer',
  templateUrl: './user-roles-cell-viewer.component.html',
  styleUrl: './user-roles-cell-viewer.component.scss'
})
export class UserRolesCellViewerComponent implements OnInit, CellComponent {
  fieldDefinition: FieldDefinition;
  invalidateSubject: InvalidateSubject;
  sourceType?: string;
  item: any;
  ngUnsubscribe$: Subject<void> = new Subject<void>();
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  hasAdminPermission: boolean;

  constructor(private dialogService: DialogService,
              private commandService: CommandService,
              private snackBarService: SnackBarService) {
  }

  ngOnInit(): void {
    // TODO: Need to check if the user has admin permission or not.
    this.hasAdminPermission = true;
  }

  AddRoleForUser() {}

  onEditRole(role: any) {
    const platformUserId = this.item.cells?.PlatformUserId?.value;
    if (this.sourceType === 'Company-User') {
      if (role.id === 'administrator') {
        const newRole = JSON.parse(JSON.stringify(role));
        newRole.id = 'manager';
        newRole.name = 'Manager';
        newRole.type = 1;
        this.switchUserRole(platformUserId, role, newRole);
      }
      if (role.id === 'manager') {
        const newRole = JSON.parse(JSON.stringify(role));
        newRole.id = 'administrator';
        newRole.name = 'Administrator';
        newRole.type = 0;
        this.switchUserRole(platformUserId, role, newRole);
      }
    }
  }

  deleteRoleForUser(role: any, action) {}

  getClassName(roleName: string) {
    switch (roleName.toLowerCase()) {
      case 'administrator':
      case 'manager':
      case 'editor':
      case 'contributor':
      case 'reviewer':
      case 'support-administrator':
      case 'support-manager':
      case 'support-follower':
      case 'support-assignee':
        return roleName.toLowerCase();
      default:
        return 'custom';
    }
  }

  isContactDialog(item: any): boolean {
    return item.cells['CanAssignRole'] && item.cells['CanAssignRole'].value === false;
  }

  switchUserRole(platformUserId: string, oldRole: any, newRole: any) {
    const title = 'Change User Role';
    const message = 'Are you sure you want to make this user ' + newRole.name + '?';
    this.dialogService.showYesNoDialog(title, message).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(result => {
      if (result.action === 'OK') {
        const command = new PlatformCommand('UpdateRoleFromAdminPanelToPlatformUserCommand', Api.Security);
        command.setValue('PlatformUserId', platformUserId);
        command.setValue('OldRoleModelIds', [oldRole.id]);
        command.setValue('NewRoleModelIds', [newRole.id]);
        command.waitForResponse = true;
        this.commandService.executePlatformCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(response => {
          this.snackBarService.showInformation('User Role Updated!');
          this.item.cells.UserRoles.value = this.item.cells.UserRoles.value.filter(v => v.id !== oldRole.id);
          this.item.cells.UserRoles.value.push(newRole);
          this.item.cells.UserRoles.displayText = this.item.cells.UserRoles.value.sort((x, y) => x.type > y.type ? 1 : -1).map(v => v.name).join(',');
          this.item.cells.UserRoles.isEdited = true;
          this.valueChanged.emit(this.item.cells.UserRoles);
        }, err => {
          this.snackBarService.showError(err.fieldValues['SnackBarMessage']);
        });
      }
    });
  }
}
